import moment from 'moment';
import {RateCardUtil} from './RateCardUtil';

export function getCantDeleteTaskMessage(intl, cantDeleteTaskReason) {
	switch (cantDeleteTaskReason) {
		case 'HAS_LOCKED_TIME':
			return intl.formatMessage({id: 'common.task_delete_locked'});
		case 'HAS_INVOICED_TIME':
			return intl.formatMessage({id: 'task.cant_delete_reason.invoice_time_regs'});
		case 'HAS_TIME_REGS':
			return intl.formatMessage({id: 'task.cant_delete_reason.time_regs'});
		case 'HAS_OTHER_PEOPLES_TIME_REGS':
			return intl.formatMessage({id: 'task.cant_delete_reason.other_peoples_time_regs'});
		case 'JIRA':
			return intl.formatMessage({id: 'task.cant_delete_reason.jira'});
		case 'GITHUB':
			return intl.formatMessage({id: 'task.cant_delete_reason.github'});
		case 'UNIT4':
			return intl.formatMessage({id: 'task.cant_delete_reason.unit4'});
		case 'NO_USER_TYPE':
		default:
			return intl.formatMessage({id: 'common.no_delete_rights'});
	}
}

export function getTaskRoleId(task) {
	return task.roleId ? task.roleId : task.role ? task.role.id : undefined;
}

export function getTaskPlannedDate(task) {
	let plannedDate;
	if (task.deadlineYear && task.deadlineMonth && task.deadlineDay) {
		plannedDate = moment.utc({y: task.deadlineYear, M: task.deadlineMonth - 1, d: task.deadlineDay});
	} else if (task.startYear && task.startMonth && task.startDay) {
		plannedDate = moment.utc({y: task.startYear, M: task.startMonth - 1, d: task.startDay});
	}
	return plannedDate;
}

export class TaskFinancialsCalculator {
	constructor(taskList, rateCard) {
		this.init(taskList, rateCard);
	}

	init(taskList, rateCard) {
		this.rateCardUtil = new RateCardUtil(rateCard);
		this.taskMap = new Map();
		this.totalRemainingRevenueInPast = 0;
		this.updateTasks(taskList);
	}

	getTotalRemainingRevenueInPast() {
		return this.totalRemainingRevenueInPast;
	}

	updateTasks(tasks) {
		for (const task of tasks) {
			const remainingTimeInPast = this.getRemainingRevenueInPast(task.node);
			this.totalRemainingRevenueInPast += remainingTimeInPast;
		}
	}

	getRemainingRevenueInPast(task) {
		const endDate = getTaskPlannedDate(task);
		if (endDate > new Date()) {
			return 0;
		}
		return (task.timeLeft / 60) * this.rateCardUtil.getRate(getTaskRoleId(task), new Date());
	}
}
